export * from './OfferDetailsSinglePropertySkeletonLoader';
